// External Imports
import React from 'react';
import PropTypes from 'prop-types';

import Chart from 'react-apexcharts';

import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';

import { useTimezoneContext } from '../utils/TimezoneContext';
import { shiftToTimezone } from '../utils/tzFormat';

//Show Telemetry Graphs
export default function StarlinkTelemetry({ telemetry, resolution }) {
  const { timezone } = useTimezoneContext();
  const format_mbps = (mbps) => {
    if (mbps > 1) {
      return Math.round(mbps) + ' Mbps';
    }
    const kbps = mbps * 1000;
    return Math.round(kbps) + ' kbps';
  };

  const format_pct = (pct) => {
    return pct.toFixed(1) + ' %';
  };
  const format_pct_loss = (pct) => {
    if (pct === 0) return '0 %';
    if (pct < 0.1) return pct.toFixed(3) + ' %';
    if (pct < 1) return pct.toFixed(2) + ' %';
    return pct.toFixed(1) + ' %';
  };
  const format_ms = (ms) => {
    return Math.round(ms) + ' ms';
  };

  const getOptions = (metric, title, formatter) => {
    const options = {
      chart: {
        id: metric + '_' + resolution,
        toolbar: {
          show: false,
        },
        zoom: {
          enabled: false,
        },
      },
      title: {
        text: title,
      },
      xaxis: {
        type: 'datetime',
        labels: {
          datetimeUTC: true,
          datetimeFormatter: {
            year: 'yyyy',
            month: "MMM 'yy",
            day: 'dd MMM',
            hour: 'HH:mm',
          },
        },
      },
      tooltip: {
        shared: true,
        intersect: false,
      },
      dataLabels: {
        enabled: false,
      },
      yaxis: {
        labels: {
          formatter: formatter,
        },
      },
    };
    return options;
  };

  const getSeries = (name, metrics) => {
    const series = [
      {
        name: name,
        data: Object.entries(metrics).map(([ts, val]) => [
          shiftToTimezone(parseInt(ts) * 1000, timezone),
          val,
        ]),
      },
    ];
    return series;
  };

  // View
  return (
    <>
      <Row>
        <Col>
          {telemetry.terminal.downlink_mbps &&
            resolution in telemetry.terminal.downlink_mbps.historical && (
              <Chart
                type='area'
                options={getOptions('downlink_mbps', 'Downlink Bandwidth', format_mbps)}
                series={getSeries(
                  'downlink_mbps',
                  telemetry.terminal.downlink_mbps.historical[resolution].avg,
                )}
                height='300px'
              />
            )}
        </Col>
        <Col>
          {telemetry.terminal.signal_quality &&
            resolution in telemetry.terminal.signal_quality.historical && (
              <Chart
                type='area'
                options={getOptions('signal_quality', 'Signal Quality', format_pct)}
                series={getSeries(
                  'signal_quality',
                  telemetry.terminal.signal_quality.historical[resolution].avg,
                )}
                height='300px'
              />
            )}
        </Col>
        <Col>
          {telemetry.terminal.latency_ms &&
            resolution in telemetry.terminal.latency_ms.historical && (
              <Chart
                type='area'
                options={getOptions('latency_ms', 'Latency', format_ms)}
                series={getSeries(
                  'latency_ms',
                  telemetry.terminal.latency_ms.historical[resolution].avg,
                )}
                height='300px'
              />
            )}
        </Col>
      </Row>
      <Row>
        <Col>
          {telemetry.terminal.uplink_mbps &&
            resolution in telemetry.terminal.uplink_mbps.historical && (
              <Chart
                type='area'
                options={getOptions('uplink_mbps', 'Uplink Bandwidth', format_mbps)}
                series={getSeries(
                  'uplink_mbps',
                  telemetry.terminal.uplink_mbps.historical[resolution].avg,
                )}
                height='300px'
              />
            )}
        </Col>
        <Col>
          {telemetry.terminal.obstruction_pct &&
            resolution in telemetry.terminal.obstruction_pct.historical && (
              <Chart
                type='area'
                options={getOptions('obstruction_pct', 'Obstructed View', format_pct)}
                series={getSeries(
                  'obstruction_pct',
                  telemetry.terminal.obstruction_pct.historical[resolution].avg,
                )}
                height='300px'
              />
            )}
        </Col>
        <Col>
          {telemetry.terminal.packet_loss_pct &&
            resolution in telemetry.terminal.packet_loss_pct.historical && (
              <Chart
                type='area'
                options={getOptions('packet_loss_pct', 'Packet Loss', format_pct_loss)}
                series={getSeries(
                  'packet_loss_pct',
                  telemetry.terminal.packet_loss_pct.historical[resolution].avg,
                )}
                height='300px'
              />
            )}
        </Col>
      </Row>

      {/*
      //routers: "uptime"
                // "latency_ms_internet"      "latency_ms_pop"      "latency_ms_dish"
                // "packet_loss_pct_internet" "packet_loss_pct_pop" "packet_loss_pct_dish"
                // "clients_2G" "clients_5G" "clients_ETH"
                // "rx_bytes" "tx_bytes"
      */}
    </>
  );
}

StarlinkTelemetry.propTypes = {
  telemetry: PropTypes.object,
  resolution: PropTypes.string,
};
